// Standard competition ranking ("1224"): items tied on scoreKey share the
// same rank, and the next distinct score resumes at its 1-based position
// (so a 2-way tie for 1st is followed by 3rd, not 2nd). `items` must already
// be sorted descending by scoreKey.
export function assignRanks(items, scoreKey) {
  let rank = 0;
  let prevScore = null;
  return items.map((item, i) => {
    if (prevScore === null || item[scoreKey] !== prevScore) {
      rank = i + 1;
      prevScore = item[scoreKey];
    }
    return { ...item, rank };
  });
}
